module.exports = __webpack_public_path__ + "img/wujinmu6.31f82d79.jpg";